import React from 'react';
import {
  healthStatusRed,
  healthStatusGreen,
  healthStatusYellow
} from '../../../../models/status/utils';


const HealthIndicators = props => {
  switch (props.status && props.status.health) {
    case healthStatusRed:
      return <i className="is-red fas fa-times"></i>;
    case healthStatusGreen:
      return <i className="is-green fas fa-check"></i>;
    case healthStatusYellow:
      return <i className="is-yellow fas fa-minus fa-2x"></i>;
    default:
      return '';
  }
};

export default HealthIndicators;



// WEBPACK FOOTER //
// ./src/components/data/status/common/healthIndicators.js